// extracted by mini-css-extract-plugin
export var sm = "768";
export var md = "1024";
export var lg = "1280";
export var xl = "1600";
export var wrapper = "SquareBlock-module--wrapper--O69bT";
export var inner = "SquareBlock-module--inner--oz2E4";